import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar } from "@climatepartner/components";
const AvatarSlot = ({ slots, header }) => {
    const { givenName = "", familyName = "" } = header?.user || {};
    if (slots?.avatar) {
        return _jsx(_Fragment, { children: slots.avatar });
    }
    if ((!familyName || !givenName) && process.env.NODE_ENV === "development") {
        // eslint-disable-next-line no-console
        console.warn("AvatarSlot: Missing user data for avatar slot");
    }
    return (_jsxs(Avatar, { children: [(header?.user?.givenName ?? "").substring(0, 1), (header?.user?.familyName ?? "").substring(0, 1)] }));
};
export default AvatarSlot;
//# sourceMappingURL=AvatarSlot.js.map